module.exports = __webpack_public_path__ + "static/media/expenses.4cef0d73.svg";